// extracted by mini-css-extract-plugin
module.exports = {"author":"Item_author__3c19v","content":"Item_content__2hGyE","date":"Item_date__2VWjK","text":"Item_text__f3AkE","user":"Item_user__mBxIX"};